module.exports = __webpack_public_path__ + "img/red-hammock-inside-room-3263716.c6aadf30.jpg";